/**
 * What a person is allowed to do on a board, and how the server tells them
 * (SRS D4).
 *
 * The server decides this and nobody else. It is sent down the same connection the
 * board itself travels on, so a teacher's one tap reaches the student immediately
 * rather than on their next page load.
 *
 * Each state is its own message rather than a message with a value inside it: the
 * whole message is then one number, which both ends already know how to read, and
 * neither side needs to unpack a payload to find out what happened.
 *
 * The numbers are on the wire, so they are fixed. 0 to 3 belong to the sync library.
 */
/** The message that says each thing. Never renumber: an open tab would misread it. */
export const ACCESS_MESSAGES = {
    view: 4,
    edit: 5,
    removed: 6,
    ended: 7,
};
/** Every access state, for anything that needs to walk them all. */
export const ACCESS_STATES = ['view', 'edit', 'removed', 'ended'];
/** The message number that says this. */
export function accessMessageId(state) {
    return ACCESS_MESSAGES[state];
}
/** What a message number says, or null if it is not one of ours. */
export function accessFromMessageId(id) {
    return ACCESS_STATES.find((state) => ACCESS_MESSAGES[state] === id) ?? null;
}
/** Whether this person may put anything on the board. */
export function canDraw(state) {
    return state === 'edit';
}
//# sourceMappingURL=board-access.js.map